/** Map-backed LRU cache evicting the least-recently-used entry on overflow. */
export class LruCache {
    map_ = new Map();
    max_;
    constructor(max) {
        if (max <= 0)
            throw new Error(`LruCache max must be > 0, got ${max}`);
        this.max_ = max;
    }
    /** Look up a key; while at capacity, touch it to the MRU end. */
    get(key) {
        // Below capacity nothing is ever evicted, so skip MRU promotion.
        if (this.map_.size < this.max_)
            return this.map_.get(key);
        const v = this.map_.get(key);
        if (v === undefined && !this.map_.has(key))
            return undefined;
        this.map_.delete(key);
        this.map_.set(key, v);
        return v;
    }
    /** Insert or refresh `key`, dropping the LRU entry on overflow. */
    set(key, value) {
        if (this.map_.has(key)) {
            this.map_.delete(key);
        }
        else if (this.map_.size >= this.max_) {
            const oldest = this.map_.keys().next();
            if (!oldest.done)
                this.map_.delete(oldest.value);
        }
        this.map_.set(key, value);
    }
    /** Inspect a key without MRU promotion. */
    peek(key) {
        return this.map_.get(key);
    }
    get size() {
        return this.map_.size;
    }
    clear() {
        this.map_.clear();
    }
}
//# sourceMappingURL=lruCache.js.map